import { get } from "lodash";
import { DEFAULT_MAX_INSTANCES } from "@searchui-searchforms/shared/constants";
import { useFormStore } from "@/widgets/classic-form/form";
import { getEventModelName } from "@/entities/data-model";
import type { EventFieldset } from "@/entities/form-metadata";

interface UseIsNewEventEnabledProps {
    fieldset: EventFieldset;
}

export const useIsNewEventEnabled = ({ fieldset }: UseIsNewEventEnabledProps) =>
    useFormStore(({ values }) => {
        const instances = get(values, `events.${getEventModelName(fieldset)}.instances`, []);
        const currentItemCount = instances.length;

        return currentItemCount >= (fieldset.maxInstances ?? DEFAULT_MAX_INSTANCES);
    });
